<div *ngIf="isPublishing" class="mfr-spinner-overlay">
  <span>Publishing...</span>
</div>

<header class="mfr-header">
  <div class="mfr-header-inner">

    <!-- Brand: logo + app title -->
    <a routerLink="/flashreport" class="mfr-brand">
      <img src="assets/images/universal-logo.png" class="mfr-logo" alt="Universal Pictures" />
      <span class="mfr-app-title">Marketing Flash Report</span>
    </a>

    <!-- Nav menus -->
    <nav class="mfr-nav" *ngIf="isAdmin">
      <!-- Reporting dropdown -->
      <button class="mfr-nav-btn" [matMenuTriggerFor]="reportingMenu">
        Reporting <span class="mfr-caret">▾</span>
      </button>
      <mat-menu #reportingMenu="matMenu" class="mfr-dropdown-menu">
        <a mat-menu-item routerLink="/flashreport">Edit Flash Report</a>
        <a mat-menu-item routerLink="/viewflashreport">View Flash Report</a>
        <mat-divider></mat-divider>
        <a mat-menu-item routerLink="/slatesummary">Slate Summary</a>
        <a mat-menu-item routerLink="/mediasummary">Media Summary</a>
        <a mat-menu-item routerLink="/flashsummary">Flash Summary</a>
        <a mat-menu-item routerLink="/departmentsummary">Department Summary</a>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="publishAll()">Publish All</button>
      </mat-menu>

      <!-- Security Setup dropdown -->
      <button class="mfr-nav-btn" [matMenuTriggerFor]="securityMenu">
        Security Setup <span class="mfr-caret">▾</span>
      </button>
      <mat-menu #securityMenu="matMenu" class="mfr-dropdown-menu">
        <a mat-menu-item routerLink="/adduser">Manage Users</a>
        <a mat-menu-item routerLink="/managetitle">Manage Title Permission</a>
        <a mat-menu-item routerLink="/managegroups">Manage Group Permission</a>
      </mat-menu>

      <!-- View Reports — direct link -->
      <a routerLink="/viewreports" class="mfr-nav-btn mfr-nav-link">View Reports</a>
    </nav>

    <nav class="mfr-nav" *ngIf="auth.currentUser() && !isAdmin">
      <a routerLink="/viewreports" class="mfr-nav-btn mfr-nav-link">View Reports</a>
    </nav>

    <div class="mfr-header-spacer"></div>

    <!-- Welcome / Sign Out -->
    <div class="mfr-user-bar" *ngIf="displayName">
      <span class="mfr-welcome-text">Welcome, <strong>{{ displayName }}</strong></span>
      <button class="mfr-signout-btn" (click)="showLogoutPopup()">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16" style="vertical-align:-1px;margin-right:4px"><path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/><path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/></svg>
        Sign Out
      </button>
    </div>

  </div>
</header>

<!-- Logout confirmation modal -->
<div class="modal fade show d-block" tabindex="-1" *ngIf="showLogoutConfirm"
     style="background:rgba(0,0,0,.55)">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Confirm Sign Out</h5>
        <button type="button" class="close" (click)="cancelLogout()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to sign out?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="logout()">Sign Out</button>
        <button type="button" class="btn btn-secondary" (click)="cancelLogout()">Cancel</button>
      </div>
    </div>
  </div>
</div>
